import { createActions } from 'utils/redux';

export const { Types, Creators } = createActions({
  triggerSnack: ['message', 'snackType'],
  clearSnack: []
});
